
<ng-template #content>
  <app-modal-wrapper>
    <ng-content></ng-content>
  </app-modal-wrapper>
</ng-template>
